import React, { useState } from 'react'
import TaskForm from './TaskForm'

function TaskGroup({taskGroup,masters,getMasterLabel,onSuccess}) {


    const [showMore,setShowMore] = useState(false);

    const countNullEndDates = (dataArray) => {
        // Use the Array.prototype.filter() method to create a new array 
        // containing only the objects where 'endDate' is exactly null.
        const nullEndDates = dataArray.filter(item => item.endDate === null);

        // Return the length of the filtered array.
        return nullEndDates.length;
    };

    return (
        <div className="card mb-2 bg-dark text-white border-primary">
            <div className="card-header border-primary text-info bg-dark">{taskGroup.title} ({taskGroup.taskList.length}) </div>
            <div className="card-body p-0">
                {taskGroup.taskList.map(task=>
                    task.endDate !== null &&
                    <TaskForm key={task.id} masters={masters} onSuccess={onSuccess} data={task} getMasterLabel={getMasterLabel} />
                )}

                {countNullEndDates(taskGroup.taskList) > 0 &&
                    <div type="button" className=" text-white bg-success ps-2" onClick={()=>setShowMore(!showMore)}>Queued Task List</div>
                }
                

                {showMore && taskGroup.taskList.map(task=>
                    task.endDate === null &&
                    <TaskForm key={task.id} masters={masters} onSuccess={onSuccess} data={task} getMasterLabel={getMasterLabel} />
                )}
                {/*<div className="text-center">
                    <TaskForm masters={masters} onSuccess={onSuccess} />
                </div>
                */}
            </div>
        </div>
        
    )
}

export default TaskGroup